export const getMonthLength = (month: number, year: number) => {
  const isFebruary = Number(month) === 1
  if (isFebruary) {
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
    return isLeapYear ? 29 : 28
  }
  const isShortMonth = [3, 5, 8, 10].includes(Number(month))
  return isShortMonth ? 30 : 31
}
